import { FC } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import QuizTypes from 'types/QuizTypes';
import QuestionTypes from 'types/QuestionTypes';
// Models
import IQuiz from 'models/Quiz';
import IQuestion from 'models/Question';
import { IAnswerResult } from 'models/Answer';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Actions
import { setAnswerTime, setAnswers, setBuckets, setQuestionEnd } from 'store/player/playerSlice';
// Selectors
import { selectQuiz, selectQuestionsLength, selectQuestion } from 'store/quiz/quizSelectors';
import {
  selectQuestionReady, selectQuestionAnswerRefs, selectCurrentQuestionIndex,
  selectAnswersByAnswerRefs, selectBucketsByAnswerRefs
} from 'store/player/playerSelectors';

const QuestionPersonalityBar:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const question:IQuestion = useAppSelector(selectQuestion);
  const questionsLength:number = useAppSelector(selectQuestionsLength);
  const questionReady:boolean = useAppSelector(selectQuestionReady);
  const questionAnswerRefs:string[] = useAppSelector(selectQuestionAnswerRefs);
  const currentQuestionIndex = useAppSelector(selectCurrentQuestionIndex);

  const answers:IAnswerResult[] = useAppSelector(selectAnswersByAnswerRefs);
  const buckets:any = useAppSelector(selectBucketsByAnswerRefs);

  const handleClick = () => {
    dispatch(setAnswers(answers));
    dispatch(setBuckets(buckets));
    dispatch(setQuestionEnd(true));
    dispatch(setAnswerTime(0));
  }

  const disabled = !questionAnswerRefs.length;

  if ( [QuizTypes.Scoring, QuizTypes.Prediction].includes(quiz.type) ) return null;
  if ( !questionReady || questionsLength <= 1 ) return null;
  return (
    <div
      className="
        absolute right-0 bottom-0 left-0
        flex items-center gap-3
        bg-gradient-to-t from-black to-transparent
        pt-4 px-3 pb-2
      "
    >
      <span className="text-white text-sm font-bold">
        {currentQuestionIndex}&nbsp;/&nbsp;{questionsLength}
      </span>
      <span className="flex-grow"></span>
      {question.type === QuestionTypes.MultiChoice ? (
        <button
          className={`
            bg-orange-400 hover:bg-orange-500
            text-sm py-2 px-4 rounded-2xl
            font-semibold text-white
            uppercase
            ${disabled ? 'pointer-events-none opacity-60' : ''}
          `}
          type="button"
          disabled={disabled}
          onClick={handleClick}
        >{t('buttons.next')}</button>
      ) : null}
    </div>
  )
}

export default QuestionPersonalityBar;
